import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const publicRoutes = [
  '/login',
  '/register',
  '/learning-path',
  '/forgot-password',
  '/reset-password',
]

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginPage.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/RegisterPage.vue')
  },
  {
    path: '/account',
    name: 'Profile',
    component: () => import('@/views/Profile.vue')
  },
  {
    path: '/learning-path',
    name: 'LearningPath',
    component: () => import('@/views/LearningPath.vue')
  },
  {
    path: '/progress',
    name: 'QuizProgress',
    component: () => import('@/views/Account.vue')
  },
  {
    path: '/accomplishment/verify/:certificateId',
    name: 'Accomplishment',
    component: () => import('@/views/Accomplishment.vue')
  },
  {
    path: '/admin/',
    name: 'QuizProgress',
    component: () => import('@/views/Lesson.vue'),
    meta: { isAdmin: true }
  },
  {
    path: '/admin/users',
    name: 'QuizProgress',
    component: () => import('@/views/Users.vue'),
    meta: { isAdmin: true }
  },
  {
    path: '/admin/rewards',
    name: 'Reward List',
    component: () => import('@/views/RewardList.vue'),
    meta: { isAdmin: true }
  },
  {
    path: '/admin/rewards/claims',
    name: 'Reward Claims',
    component: () => import('@/views/Claimed.vue'),
    meta: { isAdmin: true }
  },
  // temp route
  {
    path: '/quiz-edit/:slug',
    name: 'QuizEdit',
    component: () => import('@/views/QuizEdit.vue'),
    meta: { isAdmin: true }
  },
  {
    path: '/rewards',
    name: 'Rewards',
    component: () => import('@/views/Rewards.vue')
  },
  {
    path: '/quiz',
    name: 'Quiz',
    component: () => import('@/views/QuizList.vue')
  },
  {
    path: '/quiz/:slug',
    name: 'Quiz',
    component: () => import('@/views/Quiz.vue')
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: () => import('@/views/ForgotPassword.vue')
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: () => import('@/views/ResetPassword.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, _from, next) => {
  if (!store.state.auth.status.loggedIn) {
    if (publicRoutes.includes(to.path) === true || to.name === 'Accomplishment') {
      return next();
    }
    const name = to.name
    const { slug } = to.params
    if (name === 'Quiz' && slug !== undefined) {
      store.commit('setRedirect', to.fullPath)
    }
    return next('/login')
  } else {
    const role = store.state.auth.user.role
    if (to.name === 'Home') {
      return next((role === 'admin') ? '/admin' : '/progress')
    }
    if (publicRoutes.includes(to.path) === true && to.path !== '/learning-path') {
      return next('/progress');
    }
    if (to.meta.isAdmin === true && role !== 'admin') {
      return next('/404')
    }
    return next();
  }
})

export default router
